import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';


class ArticleGridPart extends React.Component {
  
  render() {
    //console.log(this.props.articlepart);
    return (
       <CSSTransitionGroup 
          component="div" className="col-12"
          transitionName="example"
          transitionAppear={true}
          transitionAppearTimeout={200}
          transitionEnter={false}
          transitionLeave={false}>
          <div className="col-12 px-0 article-part-to-return" dangerouslySetInnerHTML={{__html: this.props.articlepart}} />
          </CSSTransitionGroup>
    );
  }

}

export default ArticleGridPart;


// WEBPACK FOOTER //
// ./js/components/ArticleGridPart.js